import uuid from 'react-uuid'

function formatPlans(plans, rules = false) {
  const formatedPlans = []

  // Encontrar o primeiro plano que tem values para determinar os tipos de planos
  const firstPlanWithValues = plans.find(plan => plan.values && plan.values.length > 0)
  
  if (!firstPlanWithValues) {
    return formatedPlans
  }

  firstPlanWithValues.values.forEach((plan) => {
    const planRule = rules.find((rule) => rule.type === plan.name)
    const factor = planRule ? planRule.factor : 3

    formatedPlans.push({
      id: uuid(),
      factor,
      oldFactor: factor,
      name: plan?.name,
      sizes: [],
    })
  })

  plans.forEach((plan) => {
    const sizeName = plan.name

    if (plan.values && plan.values.length > 0) {
      plan.values.forEach((value) => {
        const index = formatedPlans.findIndex(
          (formatedPlan) => formatedPlan.name === value.name,
        )
        if (~index) {
          formatedPlans[index].sizes.push({
            id: uuid(),
            name: sizeName,
            value: value?.price,
            oldValue: value?.price,
            upgradePrice: value?.upgradePrice || [],
          })
        }
      })
    }
  })

  return formatedPlans
}

export const format = {
  plans: (plans, rules) => formatPlans(plans, rules),
}
